import React, { Component } from 'react';
import { UX } from '@wsb/guac-widget-core';
const { MatchMedia } = UX;

export default function wrapWithDeviceDetection(WrappedComponent) {
  return class Wrapper extends Component {
    constructor() {
      super(...arguments);
      this.handleMatchMedia = this.handleMatchMedia.bind(this);
      this.state = {};
    }

    handleMatchMedia(data) {
      if (this.state.size !== data.size) {
        this.setState({ size: data.size });
      }
    }

    render() {
      const { size } = this.state;

      return (
        <div>
          <WrappedComponent { ...this.props } size={ size } />
          <MatchMedia onChange={ this.handleMatchMedia } />
        </div>
      );
    }
  };
}
